import { retrieveBrowserLocale } from "@/utils/i18n";
import { JitsiMeeting } from "@jitsi/react-sdk";
import type { IJitsiMeetingProps } from "@jitsi/react-sdk/lib/types";
import { useNavigate } from "react-router";

type IJitsiVideo = StrictOmit<IJitsiMeetingProps, "domain"> & {
  videoServer: string;
};

const defaultIframeRef = (iframeRef: { style: { height: string } }) => {
  iframeRef.style.height = "100%";
};

export const JitsiVideo = ({
  getIFrameRef = defaultIframeRef,
  ...props
}: IJitsiVideo) => {
  const navigate = useNavigate();
  return (
    <JitsiMeeting
      domain={props.videoServer}
      getIFrameRef={getIFrameRef}
      lang={retrieveBrowserLocale()} // Set UI language, overwriting built-in language detection: https://github.com/jitsi/jitsi-meet-react-sdk/issues/36
      // We want 'tile mode' by default, since that shows the patient's self view in decent size no matter the screen size
      // Implementation as per:
      // https://community.jitsi.org/t/always-and-only-tile-view/120554/6
      onApiReady={(api) => {
        api.addListener("videoConferenceJoined", () => {
          api.executeCommand("toggleTileView");
        });
      }}
      // https://jitsi.github.io/handbook/docs/dev-guide/dev-guide-iframe-events/#readytoclose
      onReadyToClose={() => {
        void navigate("/schedule");
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage("video:finished");
        }
      }}
      {...props}
    />
  );
};
